import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CartAddOnForm from '@/components/v2/CartAddOnForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CartAddOnDetails from '@/plugins/graphql/queries/v2/cart-add-on.gql';
import CartAddOnUpdate from '@/plugins/graphql/mutations/v2/cart-add-on-update.gql';
// import CartAddOnFragment from '@/plugins/graphql/fragments/v2/cart-add-on.gql';
import CartAddOns from '@/plugins/graphql/queries/v2/cart-add-ons.gql';
import { Mutation } from 'vuex-class';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { CartAddOnModel } from '@/helpers/entities/models/CartAddOnModel';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartAddOnsEdit = class CartAddOnsEdit extends mixins(AlertMixin, RouterParamsAppMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.cartAddOn = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.cartAddOn.loading;
    }
    get formData() {
        const { cartAddOn } = this;
        const data = {
            name: null,
            price: null,
            requiredPerOrder: false,
        };
        if (cartAddOn) {
            const { name, price, requiredPerOrder } = cartAddOn;
            return {
                name,
                price,
                requiredPerOrder,
            };
        }
        return data;
    }
    goToCartAddOnsPage() {
        this.$router.push({ name: 'ecommerce-add-ons' });
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.update(form)
            .then(() => {
            const msg = successfulUpdate('Cart Add On');
            this.successNotification(msg);
            this.addOnAction('SUBMIT EDIT');
            this.goToCartAddOnsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const appUuid = this.appUUID;
        const { name, price } = form;
        // const cartAddOnUuid = this.uuid;
        this.$apollo.mutate({
            mutation: CartAddOnUpdate,
            variables: {
                input: {
                    name,
                    price,
                    requiredPerOrder: form.requiredPerOrder || false,
                    cartAddOnUuid: this.uuid,
                },
            },
            // update(cache: any, result: any) {
            //   const {
            //     data: {
            //       cartAddOnUpdate: { cartAddOn },
            //     },
            //   } = result;
            //   cartAddOn.uuid = cartAddOnUuid;
            //   cache.writeFragment({
            //     id: cartAddOnUuid,
            //     fragment: CartAddOnFragment,
            //     data: cartAddOn,
            //     fragmentName: 'CartAddOn',
            //   });
            //   cache.writeQuery({
            //     query: CartAddOnDetails,
            //     variables: {
            //       cartAddOnUuid,
            //     },
            //     data: {
            //       fetchSpecificCartAddOn: cartAddOn,
            //     },
            //   });
            // },
            refetchQueries: [
                {
                    query: CartAddOns,
                    variables: {
                        appUuid,
                    },
                },
            ],
        });
    }
};
__decorate([
    Mutation('requestOnFlight')
], CartAddOnsEdit.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], CartAddOnsEdit.prototype, "requestDone", void 0);
__decorate([
    Prop({ type: String, required: true })
], CartAddOnsEdit.prototype, "uuid", void 0);
CartAddOnsEdit = __decorate([
    Component({
        components: {
            PageTitle,
            CartAddOnForm,
        },
        apollo: {
            cartAddOn: {
                query: CartAddOnDetails,
                variables() {
                    const cartAddOnUuid = this.uuid;
                    return {
                        cartAddOnUuid,
                    };
                },
                update(data) {
                    return new CartAddOnModel(data.fetchSpecificCartAddOn);
                },
            },
        },
    })
], CartAddOnsEdit);
export default CartAddOnsEdit;
